import { Component, OnInit } from '@angular/core';
import { CONSTANTS } from '../../models/constants';

import {
  BrandingService,
  BrandProfile,
} from 'src/app/shared/branding/branding.service';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
})
export class LandingPageComponent implements OnInit {
  readonly brand: BrandProfile;

  constructor(branding: BrandingService) {
    this.brand = branding.brand;
  }

  showWarning = false;

  ngOnInit() {
    const storedPermissions = localStorage.getItem(CONSTANTS.AUTHORIZATION);
    if (
      !storedPermissions &&
      storedPermissions !== CONSTANTS.VIEW_SMS_APPLICATION
    ) {
      this.showWarning = true;
    }
  }
}
